import { createContext } from 'react';
import { ModalManager } from './modal-manager.types';

export const ModalManagerContext = createContext<ModalManager | undefined>(undefined);
